import { useHistory } from "react-router-dom";
import cx from "classnames";

import routes from "routes";
import useAppContext from "components/AppContext";
import {
  CLINICAL_PROGRAM,
  CORE_PRODUCT,
  DIABETES_PROGRAM,
  DIABETES_WORKSHOP_PROGRAM,
  GLP1_PROGRAM,
  GLP1_WORKSHOP_PROGRAM,
  PREMIUM_PRODUCT
} from "utils/resultFunctions/constants";
import t, { AsHtml } from "utils/translate";

import ContentGutter from "components/ContentGutter";
import SiteWrapper from "components/SiteWrapper";
import { getWeightLossChartData } from "components/Profile/utils/getWeightLossResults";
import RecipeRecommendations from "components/Results/RecipeRecommendations";
import Coaches from "components/Results/Coaches";
import WeightLossChart from "components/Results/WeightLossChart";
import { ResultsChecklist } from "./ResultsChecklist";
import LoadingInterstitial from "components/Results/LoadingInterstitial";

import styles from "./styles.module.scss";

export const ResultsUni5Default: React.FC<{
  resultsScreen: string;
  resultsRestored?: boolean;
  blur?: boolean;
}> = ({ resultsScreen, resultsRestored, blur = false }) => {
  const history = useHistory();
  const { profile, newQuiz } = useAppContext();

  const chartHeader = {
    [CORE_PRODUCT]: t("CHART_POINTS"),
    [PREMIUM_PRODUCT]: t("CHART_POINTS_WORKSHOP"),
    [DIABETES_PROGRAM]: t("CHART_DIABETES"),
    [DIABETES_WORKSHOP_PROGRAM]: t("CHART_DIABETES_WORKSHOP"),
    [GLP1_PROGRAM]: t("CHART_GLP1"),
    [GLP1_WORKSHOP_PROGRAM]: t("CHART_GLP1_WORKSHOP"),
    [CLINICAL_PROGRAM]: t("CHART_CLINICAL")
  };

  const chartDisclaimer = {
    [CORE_PRODUCT]: t("WEIGHT_LOSS_DISCLAIMER"),
    [PREMIUM_PRODUCT]: t("WEIGHT_LOSS_DISCLAIMER"),
    [DIABETES_PROGRAM]: t("WEIGHT_LOSS_DISCLAIMER"),
    [DIABETES_WORKSHOP_PROGRAM]: t("WEIGHT_LOSS_DISCLAIMER"),
    [GLP1_PROGRAM]: t("JOIN_SEQUENCE_ELIGIBLE_DISCLAIMER"),
    [GLP1_WORKSHOP_PROGRAM]: t("JOIN_SEQUENCE_ELIGIBLE_DISCLAIMER"),
    [CLINICAL_PROGRAM]: t("JOIN_SEQUENCE_ELIGIBLE_DISCLAIMER")
  };

  const { weightLoss, weightLossDate } = getWeightLossChartData({
    profile,
    showClinicalChart: [
      CLINICAL_PROGRAM,
      GLP1_PROGRAM,
      GLP1_WORKSHOP_PROGRAM
    ].includes(resultsScreen)
  });

  const onContinue = () => {
    if (resultsRestored) {
      history.push(routes.pricingRestored);
    } else {
      history.push(routes.pricing);
    }
  };

  return (
    <div>
      { !resultsRestored && <LoadingInterstitial
        className={styles.loading}
        headerText={t("RESULTS_LOADING_UPDATING")}
        hideSubheader
      /> }
      <div className={cx({ [styles.blur]: blur })}>
        <div className={styles.wrapper}>
          <SiteWrapper size="small">
            <ContentGutter>
              <div className={styles.chartWrapper}>
                <div className={styles.eyebrow}>
                  {t("CLINIC_CHECKOUT_PROGRAM_HEADING")}
                </div>
                <div className={styles.chartHeader}>
                  <AsHtml
                    value={chartHeader[resultsScreen]}
                    tagType="h1"
                    interpolations={{
                      weightLoss: weightLoss,
                      weightLossDate: weightLossDate
                    }}
                  />
                </div>
                <WeightLossChart
                  profile={profile}
                  newQuiz={newQuiz}
                  showHeader={false}
                  showDisclaimer={false}
                />
                <div className={styles.chartDisclaimer}>
                  <AsHtml value={chartDisclaimer[resultsScreen]} />
                </div>
              </div>
              <ResultsChecklist resultsScreen={resultsScreen} />
              <button
                className={styles.cta}
                onClick={onContinue}
                da-label="continue-to-pricing-cards"
                da-category="quiz"
                da-action="continue-to-pricing-cards"
              >
                {t("CONTINUE_TO_PRICING")}
              </button>
            </ContentGutter>
          </SiteWrapper>
        </div>
        <div className={styles.whiteWrapper}>
          <RecipeRecommendations />
          <Coaches />
        </div>
      </div>
    </div>
  );
};
